import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

export interface TutorContextPayload {
    courseId: number;
    courseTitle: string;
    courseDescription: string;
    sectionId: number;
    sectionTitle: string;
    sectionDescription: string;
    contentType: string;
    activityId?: number;
    activityTitle?: string;
    activityDescription?: string;
}

@Injectable({ providedIn: 'root' })
export class TutorContextService {
    private appUrl: string = '';

    constructor() {
        this.appUrl = environment.envVar.MSC_APP_URL.replace(/\/$/, '');
        if (window.location.ancestorOrigins && window.location.ancestorOrigins.length > 0) {
            this.appUrl = window.location.ancestorOrigins[0];
        } else if (document.referrer) {
            try {
                this.appUrl = new URL(document.referrer).origin;
            } catch (e) {
                // mantener el valor por defecto
            }
        }
    }

    sendTutorContext(payload: TutorContextPayload): void {
        if (window.parent !== window) {
            window.parent.postMessage({ type: 'tutor_context', ...payload }, this.appUrl);
        }
    }
}
